import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd908b67"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-overlay" }
const _hoisted_2 = { class: "loading-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1 /* HOISTED */))
const _hoisted_4 = { class: "loading-text" }
const _hoisted_5 = {
  key: 0,
  class: "loading-subtext"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString($props.text), 1 /* TEXT */),
      ($props.subtext)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($props.subtext), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}